import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import CenterPanelCallerDetail from './centerPanelCallerDetail';
import CenterPanelSent from './centerPanelSent';
import CenterPanelCallerJoined from './centerPanelCallerJoined';
import CenterPanelExpired from './centerPanelExpired';
import RightPanelTop from './rightPanelTop';
import RightPanelBottom from './rightPanelBottom';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';
import { useFormik } from 'formik';
import RegexValidationHelper from '../../../helpers/regexValidation.js';
import libphonenumber from 'google-libphonenumber';
import { phoneTypesEnum } from 'businessLogic/validation.js';
import { getRemainingSecond } from 'businessLogic/datetime.js';
import { connect } from 'react-redux';

export default function SendConsultNowInvitationContent(props) {
  const consultNowVidyoRoomId = useSelector((state) => state.waitingAreaReducer.consultNowVidyoRoomId);
  const showConsultNowInvitationModal = useSelector((state) => state.modalReducer.showConsultNowInvitationModal);

  const [showFirstNameErrorDetail, setShowFirstNameErrorDetail] = useState(false);
  const [showLastNameErrorDetail, setShowLastNameErrorDetail] = useState(false);
  const [showEmailErrorDetail, setShowEmailErrorDetail] = useState(false);
  const [showMobileErrorDetail, setShowMobileErrorDetail] = useState(false);
  const [sendInvitationSuccessfully, setSendInvitationSuccessfully] = useState(false);
  const [sendInvitationExpired, setSendInvitationExpired] = useState(false);

  const [currentConsultNowTicketId, setCurrentConsultNowTicketId] = useState(null);
  const [isCallerJoined, setIsCallerJoined] = useState(() => {
    return showConsultNowInvitationModal ? consultNowVidyoRoomId : false;
  });
  const [remainingSeconds, setRemainingSeconds] = useState(null);

  const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
  const countryCode = window.APP.CONFIGURATION.VALIDATION.CountryCode || 'GB';
  const emailRegex = RegexValidationHelper.EMAIL_REGEX;

  const formik = useFormik({
    initialValues: {
      firstName: '',
      lastName: '',
      email: '',
      mobile: '',
    },
    validate: (values, prop) => {
      const errors = {};
      if (!values.firstName.trim()) {
        errors.firstName = 'First name is required';
      }
      if (!values.email && !values.mobile) {
        errors.mobile = 'Enter a phone number or email address to send the invitation to';
      } else {
        if (values.email) {
          let emailArray = parseEmailAddresses(values.email);
          if (emailArray.length > 1) {
            errors.email = APP.LANGUAGE.ShareURL.OneEmailAllowError;
          } else if (!emailRegex.test(values.email.trim())) {
            errors.email = APP.LANGUAGE.ShareURL.EmailFormatError;
          }
        }

        if (values.mobile) {
          if (values.mobile.indexOf(',') > -1) {
            errors.mobile = APP.LANGUAGE.ShareURL.OneMobileAllowError;
          } else {
            try {
              let number = phoneUtil.parseAndKeepRawInput(values.mobile, countryCode);
              if (phoneUtil.isValidNumber(number)) {
                let numberType = phoneUtil.getNumberType(number);
                if (
                  !(
                    numberType == phoneTypesEnum.MOBILE ||
                    numberType == phoneTypesEnum.FIXED_LINE_OR_MOBILE ||
                    numberType == phoneTypesEnum.PERSONAL_NUMBER
                  )
                ) {
                  errors.mobile = APP.LANGUAGE.Errors.NoValidPhoneNumber;
                }
              } else {
                errors.mobile = APP.LANGUAGE.Errors.NoValidPhoneNumber;
              }
            } catch (err) {
              errors.mobile = APP.LANGUAGE.Errors.NoValidPhoneNumber;
            }
          }
        }
      }

      return errors;
    },
  });
  useEffect(() => {
    if (!formik.errors.firstName) {
      setShowFirstNameErrorDetail(false);
    }
    if (!formik.errors.lastName) {
      setShowLastNameErrorDetail(false);
    }
    if (!formik.errors.mobile) {
      setShowMobileErrorDetail(false);
    }
    if (!formik.errors.email) {
      setShowEmailErrorDetail(false);
    }
  }, [formik.errors.firstName, formik.errors.lastName, formik.errors.email, formik.errors.mobile]);

  useEffect(() => {
    // Calculate the update remaining time
    if (props.consultNowInitiatedRoomsFiltered && props.consultNowInitiatedRoomsFiltered.length > 0) {
      let gotConsultNotTicket = props.consultNowInitiatedRoomsFiltered.find(
        (x) => x.authTicketId == currentConsultNowTicketId
      );
      if (!!gotConsultNotTicket) {
        let seonds = 0;
        if (!!gotConsultNotTicket.expiryDate) {
          seonds = getRemainingSecond(gotConsultNotTicket.expiryDate);
          setRemainingSeconds(seonds);
        }
      }
    }
  }, [props.consultNowInitiatedRoomsFiltered]);
  // useEffect(() => {
  //   return () => {
  //     // UnSubscribing CN pubnub when modal is closed
  //     unSubscribPubnubChannels([PUBNUB_CHANNELS.CONSULT_NOW + currentConsultNowTicketId]);
  //   };
  // }, [currentConsultNowTicketId]);

  useEffect(() => {
    if (consultNowVidyoRoomId) setIsCallerJoined(consultNowVidyoRoomId);
    return () => {
      setIsCallerJoined(false);
    };
  }, [consultNowVidyoRoomId]);

  const parseEmailAddresses = (emails) => {
    let emailArray = emails.trim().split(/[\s,]+/);
    if (Array.isArray(emailArray)) {
      return emailArray;
    } else {
      return [emails];
    }
  };

  return (
    <Modal show={true} hideWhenClickAway={false} className="fixed-header-footer-mobile">
      <PopupHeader
        title={APP.LANGUAGE.SendConsultNowInvitation.Title}
        subtitle={props.waitingArea.name}
        hideHelp={false}
        helpLink={APP.EXTERNAL_LINKS.ConsultNow.ConsultNowInvitationDialog}
      />
      <div className={sendInvitationSuccessfully ? 'content' : 'content body-content'}>
        {sendInvitationSuccessfully ? (
          sendInvitationExpired ? (
            <CenterPanelExpired
              waitingArea={props.waitingArea}
              setSendInvitationSuccessfully={setSendInvitationSuccessfully}
              setSendInvitationExpired={setSendInvitationExpired}
              formik={formik}
            />
          ) : isCallerJoined ? (
            <CenterPanelCallerJoined
              isCallerJoined={isCallerJoined}
              waitingArea={props.waitingArea}
              currentConsultNowTicketId={currentConsultNowTicketId}
            />
          ) : (
            <CenterPanelSent
              remainingSeonds={remainingSeconds}
              consultNowRoomsFiltered={props.consultNowRoomsFiltered}
              setSendInvitationExpired={setSendInvitationExpired}
              currentConsultNowTicketId={currentConsultNowTicketId}
              formik={formik}
            />
          )
        ) : (
          <div className="main-ui-container">
            <div id="righthandfloatingpanel" style={{ minHeight: '400px' }}>
              <div className="right ui rail">
                <div className="ui sticky">
                  <RightPanelTop
                    formik={formik}
                    waitingArea={props.waitingArea}
                    parseEmailAddresses={parseEmailAddresses}
                    setSendInvitationSuccessfully={setSendInvitationSuccessfully}
                    setCurrentConsultNowTicketId={setCurrentConsultNowTicketId}
                  />
                </div>
                <RightPanelBottom />
              </div>
              <CenterPanelCallerDetail
                waitingArea={props.waitingArea}
                formik={formik}
                showFirstNameErrorDetail={showFirstNameErrorDetail}
                setShowFirstNameErrorDetail={setShowFirstNameErrorDetail}
                showLastNameErrorDetail={showLastNameErrorDetail}
                setShowLastNameErrorDetail={setShowLastNameErrorDetail}
                showMobileErrorDetail={showMobileErrorDetail}
                setShowMobileErrorDetail={setShowMobileErrorDetail}
                showEmailErrorDetail={showEmailErrorDetail}
                setShowEmailErrorDetail={setShowEmailErrorDetail}
              />
              <div className="bottom-rail-with-left-and-right-content mrtl">
                <div className="mrtm">
                  <RightPanelBottom />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {sendInvitationSuccessfully ? (
        ''
      ) : (
        <div className="bottom-rail-with-left-and-right-content mrtnull">
          <RightPanelTop
            formik={formik}
            waitingArea={props.waitingArea}
            parseEmailAddresses={parseEmailAddresses}
            setSendInvitationSuccessfully={setSendInvitationSuccessfully}
            setCurrentConsultNowTicketId={setCurrentConsultNowTicketId}
          />
        </div>
      )}
    </Modal>
  );
}
